import { Trans } from '@ui/i18n/trans';
import React, { useState } from 'react';
import CountUp from 'react-countup';
import VisibilitySensor from 'react-visibility-sensor';

export default function Numbers() {



    return (
        <div className='py-80 px-10 lg:px-80'>
            <h2 className='text-black text-center dark:text-white text-5xl md:text-[56px] font-semibold'>
                <Trans message="Candy Cloudy " />
                <span className='text-gradient-pink'><Trans message="in Numbers" /></span>
            </h2>
            <p className='text-[#888888] text-lg text-center mt-32'>
                <Trans message="Empowering Users Worldwide with Sweet, Secure Storage" />
            </p>
            <div className='flex mt-40 py-40 px-10 sm:px-40 mx-auto flex-wrap gap-y-80'>
                <div className='w-full md:w-1/2 lg:w-1/3'>
                    <div className='flex justify-center'>
                        <SingleCountUp end={10000} duration={3} suffix="+" />
                    </div>
                    <p className='text-center text-[#888888] text-lg font-medium mt-20'>
                        <Trans message="Active Users" />
                    </p>
                </div>
                <div className='w-full md:w-1/2 lg:w-1/3'>
                    <div className='flex justify-center'>
                        <SingleCountUp end={5} duration={3} />
                    </div>
                    <p className='text-center text-[#888888] text-lg font-medium mt-20'>
                        <Trans message="Petabytes Stored" />
                    </p>
                </div>
                <div className='w-full md:w-1/2 lg:w-1/3'>
                    <div className='flex justify-center'>
                        <SingleCountUp end={30} duration={3} suffix="+" />
                    </div>
                    <p className='text-center text-[#888888] text-lg font-medium mt-20'>
                        <Trans message="Countries" />
                    </p>
                </div>
            </div>
        </div>

    );
}

function SingleCountUp({ end, duration, suffix }: { end: number, duration: number, suffix?: string }) {
    const [hasStarted, setHasStarted] = useState(false);

    return (
        <CountUp start={0} end={end} duration={duration} suffix={suffix} redraw>
            {({ countUpRef, start }) => (
                <VisibilitySensor
                    onChange={(isVisible: boolean) => {
                        if (isVisible && !hasStarted) {
                            start();
                            setHasStarted(true);
                        }
                    }}
                    delayedCall
                    partialVisibility
                >
                    <span className='text-[#0154A0] text-6xl text-center font-semibold' ref={countUpRef} />
                </VisibilitySensor>
            )}
        </CountUp>
    );
};